module.exports = __webpack_public_path__ + "static/media/PM107.f0b4ac48.png";